import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Breadcrumb from '../../component/Breadcrumb';
import swal from 'sweetalert';
import Loader from '../../component/Loader/Loader';

const GenerateConfig = () => {

    const [fileName,setFileName]        = useState('Config File');
    const [softVersion,setSoftVersion]  = useState('');
    const [showLoader, setShowLoader]   = useState(false);

    const handleGenerateConfigFile = () => {
        if(fileName === '' || softVersion === ''){
            swal("Oops!", "File Name or Soft Version is empty.", "error");
            return;
        }
        setShowLoader(true);
        const keys = Object.keys(localStorage);
        let data = {
            "BDate": new Date().toLocaleDateString('en-CA',{
                year : 'numeric',
                month : '2-digit',
                day : '2-digit',
                hour : '2-digit',
                minute : '2-digit',
                hour12 : false
            }).replace(/-/g,'/').replace(',', ''),
            "SoftVer": softVersion,
        };
        keys.filter((k) => k === 'Connections' || k === 'Parameters' || k === 'Events' || k === 'ECURequestPGN' || k === 'ECUReceiveMessages' || k === 'ECUConstantTxMessages' || k === 'HomePage' || k === 'ECUIDDefinitions' || k === 'ECUTransmitMessages' || k === 'Modbus').map((key) => data[key] = localStorage?.getItem(key) ? JSON.parse(localStorage?.getItem(key)) : '');
        let jsonString = JSON.stringify(data,null,2); // In case we want the json output in a readable format takes more space.
    
        //let jsonString = JSON.stringify(data);
        const blob = new Blob([jsonString],{type:'application/json'});
        const link = document.createElement('a');
        link.download = `${fileName}.json`;
        link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setShowLoader(false);
    }


    return (
        <>
            {showLoader && 
                <Loader />
            }  
            <Breadcrumb  title="Generate Config File">
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                Generate
                </Typography>
            </Breadcrumb>
            <Box  component="section">
                <Grid className="contentBox">
                    <Grid container sx={{mt:1}} direction="row" spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                            <TextField 
                                fullWidth
                                label="Soft Version"
                                name="softVersion"
                                value={softVersion}
                                onChange={(e) => setSoftVersion(e.target.value)}
                                error={softVersion === ""}
                                helperText={softVersion === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField 
                                fullWidth
                                label="File Name"
                                name="fileName"
                                value={fileName}
                                onChange={(e) => setFileName(e.target.value)}
                                error={fileName === ""}
                                helperText={fileName === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={4} sm={6} md={6}>
                            <Button 
                                variant='contained'
                                size='small'
                                color='primary'
                                onClick={handleGenerateConfigFile}
                                sx={{mt:1}}
                            >
                                Generate
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>   
            </Box>    
        </>
    )
}

export default GenerateConfig